import { render, staticRenderFns } from "./PagesWidget.vue?vue&type=template&id=3347a4e0&scoped=true"
import script from "./PagesWidget.vue?vue&type=script&lang=js"
export * from "./PagesWidget.vue?vue&type=script&lang=js"
import style0 from "./PagesWidget.vue?vue&type=style&index=0&id=3347a4e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3347a4e0",
  null
  
)

export default component.exports